import { SelectedSecurity } from './models/selected-security';

export function selectedSecurityEquals(x: SelectedSecurity | null, y: SelectedSecurity | null) {
  return x?.id === y?.id && x?.surveillance === y?.surveillance;
}
